import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { defaultContext } from './Context';
export function setWindowConfiguration(instanceSymbol, value) {
  if (!canUseWindow() || !ownsWindowConfiguration(instanceSymbol)) {
    return;
  }
  var existingContext = getWindowConfiguration();
  var configuration = _objectSpread(_objectSpread(_objectSpread({}, existingContext), value), {}, {
    instanceSymbol: instanceSymbol
  });
  window.__flowweb_internal__ = configuration;
  window.__citrixui_internal__ = configuration;
}
function getWindowConfiguration() {
  if (canUseWindow()) {
    return window.__flowweb_internal__;
  }
}
export function getConfigurationFromWindowOrDefault() {
  var _windowConfig$configu;
  var windowConfig = getWindowConfiguration();
  return (_windowConfig$configu = windowConfig === null || windowConfig === void 0 ? void 0 : windowConfig.configuration) !== null && _windowConfig$configu !== void 0 ? _windowConfig$configu : defaultContext;
}
export function getOnNotificationFromWindowOrDefault() {
  var _windowConfig$onNotif;
  var windowConfig = getWindowConfiguration();
  return (_windowConfig$onNotif = windowConfig === null || windowConfig === void 0 ? void 0 : windowConfig.onNotification) !== null && _windowConfig$onNotif !== void 0 ? _windowConfig$onNotif : throwNoNotificationHostRendered;
}
export function getShowModalFromWindowOrDefault() {
  var _windowConfig$showMod;
  var windowConfig = getWindowConfiguration();
  return (_windowConfig$showMod = windowConfig === null || windowConfig === void 0 ? void 0 : windowConfig.showModal) !== null && _windowConfig$showMod !== void 0 ? _windowConfig$showMod : throwNoModalHostRendered;
}
export function deleteWindowConfiguration(instanceSymbol) {
  if (canUseWindow() && ownsWindowConfiguration(instanceSymbol)) {
    delete window.__flowweb_internal__;
    delete window.__citrixui_internal__;
  }
}
function ownsWindowConfiguration(instanceSymbol) {
  var _getWindowConfigurati;
  var existingSymbol = (_getWindowConfigurati = getWindowConfiguration()) === null || _getWindowConfigurati === void 0 ? void 0 : _getWindowConfigurati.instanceSymbol;
  return !existingSymbol || existingSymbol === instanceSymbol;
}
function canUseWindow() {
  return typeof window !== 'undefined';
}
function throwNoModalHostRendered() {
  throw new Error('FlowWebProvider must be rendered before opening modals with `showModal`.');
}
function throwNoNotificationHostRendered() {
  throw new Error('FlowWebProvider must be rendered before showing notifications.');
}